
import "@/styles/resource.scss";
          // window.installFramework = window.installFramework || Function.prototype
          installFramework(function(Vue) {
            
new Vue({
  data() {
    return {
      search: "",
      praise: require("@/assets/img/resource/resource-praise.svg"),
      defaultImage: require("@/assets/img/resource/defaultImage.svg"),
    };
  },

  mounted() {
    document.onscroll = function () {
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;

      const el = document.querySelector("header");
      if (scrollTop > 50) {
        el.classList.add("scrolled");
      } else {
        el.classList.remove("scrolled");
      }
    };

    const aList = document.querySelectorAll(".article-guide > a");
    const liList = document.querySelectorAll(".article-guide > a > li");
    const { search } = window.location;
    aList.forEach((el, index) => {
      if (search.indexOf(el.search) > -1) {
        liList[index].classList.add("guide-active");
      }
    });
  },

  methods: {
    searchClose() {
      this.search = "";
    },

    quickSearch(event) {
      let value = event.target.innerText;
      let lang = document.documentElement.lang;
      lang === "zh" &&
        window.open(
          `https://www.baidu.com/s?ie=utf-8&f=8&rsv_bp=1&rsv_idx=1&tn=baidu&wd=${value}`
        );
      lang !== "zh" &&
        window.open(
          `https://www.google.com/search?as_q=${value}&as_sitesearch=picwish.com`
        );
    },

    praising(event) {
      event.preventDefault();
      let el = event.target.lastChild.innerText;
      event.target.lastChild.innerText = Number(el) + 1;
    },

    num() {
      // 1～100随机数
      return Math.floor(Math.random() * 100) + 1;
    },

    getDefaultImage(event) {
      let img = event.srcElement;
      img.src = this.defaultImage;
      img.onerror = null;
    },
  },
}).$mount("#app");

          })
        